import React, { useState } from 'react';
import { useParams, Link } from 'react-router-dom';

const LOGO = '/dailyreps3.png';
const API_BASE = process.env.REACT_APP_API_URL || '';

export default function ResetPassword() {
  const { token } = useParams();
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (password !== confirmPassword) {
      setError('Passwords do not match.');
      return;
    }

    setLoading(true);
    try {
      const res = await fetch(`${API_BASE}/api/auth/reset-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, new_password: password }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || 'Something went wrong');
      setSuccess(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <img src={LOGO} alt="Train Daily" className="login-logo" />
      <h1 className="login-title">
        <span>Train Daily</span> Reset Password
      </h1>
      {success ? (
        <div style={{ textAlign: 'center', maxWidth: 360 }}>
          <p style={{ color: '#fff', fontSize: '0.95rem', lineHeight: 1.5 }}>
            Your password has been reset successfully. You can now sign in with your new password.
          </p>
          <Link
            to="/login"
            style={{ color: '#fff', textDecoration: 'underline', fontSize: '0.9rem' }}
          >
            Back to Sign In
          </Link>
        </div>
      ) : (
        <>
          <p style={{ color: '#fff', fontSize: '0.9rem', textAlign: 'center', marginBottom: 16 }}>
            Enter your new password below.
          </p>
          <form className="login-form" onSubmit={handleSubmit}>
            {error && <div className="login-error">{error}</div>}
            <input
              type="password"
              placeholder="New Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              minLength={6}
            />
            <input
              type="password"
              placeholder="Confirm Password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
              minLength={6}
            />
            <button className="btn btn-orange" type="submit" disabled={loading}>
              {loading ? 'Resetting...' : 'Reset Password'}
            </button>
          </form>
        </>
      )}
    </div>
  );
}
